import Footer from "../feautures/footer";
import Navbar from "../feautures/navbar";

export default function NavFootLayout(props) {
  return (
    <div>
      <Navbar />
      {props.children}
      <Footer/>
    </div>
  );
}
